var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "m4.266 7 3.432 3.218a.92.92 0 0 1 .002 1.36l-.15.142c-.4.376-1.052.373-1.455-.006L0 6 6.095.283A1.08 1.08 0 0 1 7.55.278l.15.14c.4.376.4.985-.002 1.36L4.265 5h9.733a1 1 0 1 1 0 2z"
  })));
};
export default SvgBackArrow;